import { Models } from "@rematch/core";

import { activeCustomerGroup } from "./activeCustomerGroup";
import { auth } from "./auth";
import { cluster } from "./cluster";
import { count } from "./count";
import { customerAddressPostalCodes } from "./customerAddressPostalCodes";
import { customerContacts } from "./customerContacts";
import { customerContactsTopFlopCombinations } from "./customerContactsTopFlopCombinations";
import { customerDensity } from "./customerDensity";
import { customerGroupEditOption } from "./customerGroupEditOption";
import { customerGroupFilter } from "./customerGroupFilter";
import { customerGroupList } from "./customerGroupList";
import { customerGroupResult } from "./customerGroupResult";
import { customerSectorsStatistics } from "./customerSectorsStatistics";
import { dashboardFilter } from "./dashboardFilter";
import { effectsColumnsData } from "./effectsColumnsData";
import { effectsData } from "./effectsData";
import { effectsFilter } from "./effectsFilter";
import { errors } from "./errors";
import { housingSituations } from "./housingSituations";
import { latLong } from "./latLong";
import { lineChartsData } from "./lineChartsData";
import { marketShare } from "./marketShare";
import { marketShareFilter } from "./marketShareFilter";
import { nbaDistribution } from "./nbaDistribution";
import { nextBestActivities } from "./nextBestActivities";
import { polygonDensity } from "./polygonDensity";
import { postalcodes } from "./postalcodes";
import { salutationsData } from "./salutationsData";
import { supplyTypesMappedToProductFamilies } from "./supplyTypesMappedToProductFamilies";
import { tariffTypesElectricity } from "./tariffTypesElectricity";
import { tariffTypesGas } from "./tariffTypesGas";
import { tariffTypesGlassFiber } from "./tariffTypesGlassFiber";
import { tariffTypesHeating } from "./tariffTypesHeating";
import { users } from "./users";

export interface RootModel extends Models<RootModel> {
  activeCustomerGroup: typeof activeCustomerGroup;
  auth: typeof auth;
  cluster: typeof cluster;
  count: typeof count;
  customerAddressPostalCodes: typeof customerAddressPostalCodes;
  customerContacts: typeof customerContacts;
  customerContactsTopFlopCombinations: typeof customerContactsTopFlopCombinations;
  customerDensity: typeof customerDensity;
  customerGroupEditOption: typeof customerGroupEditOption;
  customerGroupFilter: typeof customerGroupFilter;
  customerGroupList: typeof customerGroupList;
  customerGroupResult: typeof customerGroupResult;
  customerSectorsStatistics: typeof customerSectorsStatistics;
  dashboardFilter: typeof dashboardFilter;
  effectsColumnsData: typeof effectsColumnsData;
  effectsData: typeof effectsData;
  effectsFilter: typeof effectsFilter;
  errors: typeof errors;
  housingSituations: typeof housingSituations;
  latLong: typeof latLong;
  lineChartsData: typeof lineChartsData;
  marketShare: typeof marketShare;
  marketShareFilter: typeof marketShareFilter;
  nbaDistribution: typeof nbaDistribution;
  nextBestActivities: typeof nextBestActivities;
  polygonDensity: typeof polygonDensity;
  postalcodes: typeof postalcodes;
  salutationsData: typeof salutationsData;
  tariffTypesElectricity: typeof tariffTypesElectricity;
  tariffTypesGas: typeof tariffTypesGas;
  tariffTypesHeating: typeof tariffTypesHeating;
  tariffTypesGlassFiber: typeof tariffTypesGlassFiber;
  supplyTypesMappedToProductFamilies: typeof supplyTypesMappedToProductFamilies;
  users: typeof users;
}
export const models: RootModel = {
  activeCustomerGroup,
  auth,
  cluster,
  count,
  customerAddressPostalCodes,
  customerContacts,
  customerContactsTopFlopCombinations,
  customerDensity,
  customerGroupEditOption,
  customerGroupFilter,
  customerGroupList,
  customerGroupResult,
  customerSectorsStatistics,
  dashboardFilter,
  effectsColumnsData,
  effectsData,
  effectsFilter,
  errors,
  housingSituations,
  latLong,
  lineChartsData,
  marketShare,
  marketShareFilter,
  nbaDistribution,
  nextBestActivities,
  polygonDensity,
  postalcodes,
  salutationsData,
  tariffTypesElectricity,
  tariffTypesGas,
  tariffTypesHeating,
  tariffTypesGlassFiber,
  supplyTypesMappedToProductFamilies,
  users,
};



// WEBPACK FOOTER //
// ./src/models/index.ts